export default "__VITE_ASSET__CqhsOS_G__"